import { render } from "./slide9.vue?vue&type=template&id=3dccdde8&scoped=true"
import script from "./slide9.vue?vue&type=script&lang=js"
export * from "./slide9.vue?vue&type=script&lang=js"

import "./slide9.vue?vue&type=style&index=0&id=3dccdde8&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dccdde8"]])

export default __exports__